export enum AlertType {
  info,
  success,
  notice,
  warning,
  error
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/alert/alert.type.ts